/** The sync badge's words, picked from the situation. Wording lives in settings/sync.ts. */
import { fill } from "../settings/index.ts";
import * as T from "../settings/sync.ts";

export interface SyncInput {
  signedIn: boolean | null;
  online: boolean;
  syncStatus: string;
  pending: number;
  /** Whole seconds until the next try, or null when unknown. */
  retryIn: number | null;
}
export type SyncView = { text: string; tone: "ok" | "busy" | "warn" };

export function syncView(i: SyncInput): SyncView {
  const n = i.pending;
  const changes = n === 1 ? T.SYNC_ONE_CHANGE_TEXT : fill(T.SYNC_MANY_CHANGES_TEXT, { count: n });
  if (i.signedIn === false)
    return {
      text: n ? fill(T.SYNC_SIGNED_OUT_PENDING_TEXT, { changes }) : T.SYNC_SIGNED_OUT_TEXT,
      tone: "warn",
    };
  if (!i.online)
    return {
      text: n ? fill(T.SYNC_OFFLINE_PENDING_TEXT, { changes }) : T.SYNC_OFFLINE_TEXT,
      tone: "warn",
    };
  if (i.syncStatus === "syncing")
    return { text: n ? fill(T.SYNC_SAVING_TEXT, { changes }) : T.SYNC_CHECKING_TEXT, tone: "busy" };
  if (i.syncStatus === "offline" || i.syncStatus === "error") {
    const when =
      i.retryIn !== null ? fill(T.SYNC_RETRY_IN_TEXT, { seconds: i.retryIn }) : T.SYNC_RETRY_TEXT;
    return {
      text: fill(n ? T.SYNC_UNREACHABLE_PENDING_TEXT : T.SYNC_UNREACHABLE_TEXT, { changes, when }),
      tone: "warn",
    };
  }
  if (n) return { text: fill(T.SYNC_WAITING_TEXT, { changes }), tone: "busy" };
  return { text: T.SYNC_SAVED_TEXT, tone: "ok" };
}
